import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { ClutchIcon } from "../../../app-constants";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1801 },
    items: 2.1,
  },
  desktop: {
    breakpoint: { max: 1800, min: 1600 },
    items: 1.8,
  },
  smalldesktop: {
    breakpoint: { max: 1599, min: 1400 },
    items: 1.65,
  },
  landscape: {
    breakpoint: { max: 1399, min: 1200 },
    items: 1.8,
  },
  tablet: {
    breakpoint: { max: 1199, min: 900 },
    items: 1.4,
  },
  mobilelg: {
    breakpoint: { max: 899, min: 667 },
    items: 1.1,
  },
  mobile: {
    breakpoint: { max: 666, min: 0 },
    items: 1,
  },
};

const Associatesslider = () => {
  return (
    <div className="associatesslider p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={7}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center m-auto"
          >
            <h2>What our Clients Say</h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Carousel
              responsive={responsive}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={3000}
              showDots={false}
              arrows={false}
            >
              <div className="associates_card">
                <div className="associates_content">
                  <div className="name">
                    Hansel Graef
                    <span>Owner & Creator, Save A Spot</span>
                  </div>
                  <p>
                    “They’ve shown that they can keep their promises through
                    their work.”
                  </p>
                </div>
                <div className="associates_rating">
                  <div className="rating_number">5.0</div>

                  <ul>
                    <li>
                      Quality <span>5.0</span>
                    </li>
                    <li>
                      Schedule <span>5.0</span>
                    </li>
                    <li>
                      Cost <span>5.0</span>
                    </li>
                    <li>
                      Willing to Refer <span>5.0</span>
                    </li>
                  </ul>
                  <p>Powered by {ClutchIcon}</p>
                </div>
              </div>
              <div className="associates_card">
                <div className="associates_content">
                  <div className="name">
                    Aubrey Pascoe
                    <span>COO & Co-Founder, Dara</span>
                  </div>
                  <p>
                    “Their strength lies in their professionalism,
                    communication, and continuous follow-up.”
                  </p>
                </div>
                <div className="associates_rating">
                  <div className="rating_number">5.0</div>

                  <ul>
                    <li>
                      Quality <span>5.0</span>
                    </li>
                    <li>
                      Schedule <span>5.0</span>
                    </li>
                    <li>
                      Cost <span>5.0</span>
                    </li>
                    <li>
                      Willing to Refer <span>5.0</span>
                    </li>
                  </ul>
                  <p>Powered by {ClutchIcon}</p>
                </div>
              </div>
              <div className="associates_card">
                <div className="associates_content">
                  <div className="name">
                    Michael Haapaniemi
                    <span>President, Ranch Office</span>
                  </div>
                  <p>
                    “Their resources have knocked the project out of the park.”
                  </p>
                </div>
                <div className="associates_rating">
                  <div className="rating_number">5.0</div>

                  <ul>
                    <li>
                      Quality <span>5.0</span>
                    </li>
                    <li>
                      Schedule <span>5.0</span>
                    </li>
                    <li>
                      Cost <span>5.0</span>
                    </li>
                    <li>
                      Willing to Refer <span>5.0</span>
                    </li>
                  </ul>
                  <p>Powered by {ClutchIcon}</p>
                </div>
              </div>
            </Carousel>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Associatesslider;
